<template>
  <section class="Privacy">
    <h2>Privacy Policy</h2>

    <p>
      This privacy policy has been compiled to better serve those who are concerned with how their 'Personally Identifiable Information' (PII) is being used online. PII, as described in US privacy law and information security, is information that can be used on its own or with other information to identify, contact, or locate a single person, or to identify an individual in context. Please read our privacy policy carefully to get a clear understanding of how we collect, use, protect or otherwise handle your Personally Identifiable Information in accordance with our website.<br>
      <br>
      What personal information do we collect from the people that visit our blog, website or app?<br>
      <br>
      When ordering or registering on our site, as appropriate, you may be asked to enter your name, email address, phone number, Application Name or other details to help you with your experience.<br>
      <br>
      When do we collect information?<br>
      <br>
      We collect information from you when you place an order, subscribe to a newsletter, fill out a form, Open a Support Ticket or enter information on our site.<br>
      <br>
      <br>
      How do we use your information?<br>
      <br>
      We may use the information we collect from you when you register, make a purchase, sign up for our newsletter, respond to a survey or marketing communication, surf the website, or use certain other site features in the following ways:<br>
      <br>
      • To allow us to better service you in responding to your customer service requests.<br>
      • To ask for ratings and reviews of services or products<br>
      • To follow up with them after correspondence (live chat, email or phone inquiries)<br>
      <br>
      How do we protect your information?<br>
      <br>
      We do not use vulnerability scanning and/or scanning to PCI standards.<br>
      We only provide articles and information. We never ask for credit card numbers.<br>
      We do not use Malware Scanning.<br>
      <br>
      Your personal information is contained behind secured networks and is only accessible by a limited number of persons who have special access rights to such systems, and are required to keep the information confidential. In addition, all sensitive/credit information you supply is encrypted via Secure Socket Layer (SSL) technology.<br>
      <br>
      We implement a variety of security measures when a user enters, submits, or accesses their information to maintain the safety of your personal information.<br>
      <br>
      All transactions are processed through a gateway provider and are not stored or processed on our servers.<br>
      <br>
      Do we use 'cookies'?<br>
      <br>
      Yes. Cookies are small files that a site or its service provider transfers to your computer's hard drive through your Web browser (if you allow) that enables the site's or service provider's systems to recognize your browser and capture and remember certain information. For instance, we use cookies to help us remember and process the items in your shopping cart. They are also used to help us understand your preferences based on previous or current site activity, which enables us to provide you with improved services. We also use cookies to help us compile aggregate data about site traffic and site interaction so that we can offer better site experiences and tools in the future.<br>
      <br>
      We use cookies to:<br>
      • Understand and save user's preferences for future visits.<br>
      • Keep track of advertisements.<br>
      • Compile aggregate data about site traffic and site interactions in order to offer better site experiences and tools in the future. We may also use trusted third-party services that track this information on our behalf.<br>
      <br>
      You can choose to have your computer warn you each time a cookie is being sent, or you can choose to turn off all cookies. You do this through your browser settings. Since browser is a little different, look at your browser's Help Menu to learn the correct way to modify your cookies.<br>
      <br>
      If users disable cookies in their browser:<br>
      <br>
      If you turn cookies off, Some of the features that make your site experience more efficient may not function properly.Some of the features that make your site experience more efficient and may not function properly.<br>
      <br>
      <br>
      Third-party disclosure<br>
      <br>
      We do not sell, trade, or otherwise transfer to outside parties your Personally Identifiable Information unless we provide users with advance notice. This does not include website hosting partners and other parties who assist us in operating our website, conducting our business, or serving our users, so long as those parties agree to keep this information confidential. We may also release information when it's release is appropriate to comply with the law, enforce our site policies, or protect ours or others' rights, property or safety.<br>
      <br>
      However, non-personally identifiable visitor information may be provided to other parties for marketing, advertising, or other uses.<br>
      <br>
      Third-party links<br>
      <br>
      Occasionally, at our discretion, we may include or offer third-party products or services on our website. These third-party sites have separate and independent privacy policies. We therefore have no responsibility or liability for the content and activities of these linked sites. Nonetheless, we seek to protect the integrity of our site and welcome any feedback about these sites.<br>
      <br>
      Google<br>
      <br>
      Google's advertising requirements can be summed up by Google's Advertising Principles. They are put in place to provide a positive experience for users. https://support.google.com/adwordspolicy/answer/1316548?hl=en<br>
      <br>
      We use Google AdSense Advertising on our website.<br>
      <br>
      Google, as a third-party vendor, uses cookies to serve ads on our site. Google's use of the DART cookie enables it to serve ads to our users based on previous visits to our site and other sites on the Internet. Users may opt-out of the use of the DART cookie by visiting the Google Ad and Content Network privacy policy.<br>
      <br>
      We have implemented the following:<br>
      • Remarketing with Google AdSense<br>
      • Google Display Network Impression Reporting<br>
      • Demographics and Interests Reporting<br>
      • DoubleClick Platform Integration<br>
      <br>
      We, along with third-party vendors such as Google use first-party cookies (such as the Google Analytics cookies) and third-party cookies (such as the DoubleClick cookie) or other third-party identifiers together to compile data regarding user interactions with ad impressions and other ad service functions as they relate to our website.<br>
      <br>
      Opting out:<br>
      Users can set preferences for how Google advertises to you using the Google Ad Settings page. Alternatively, you can opt out by visiting the Network Advertising Initiative Opt Out page or by using the Google Analytics Opt Out Browser add on.<br>
      <br>
      California Online Privacy Protection Act<br>
      <br>
      CalOPPA is the first state law in the nation to require commercial websites and online services to post a privacy policy. The law's reach stretches well beyond California to require any person or company in the United States (and conceivably the world) that operates websites collecting Personally Identifiable Information from California consumers to post a conspicuous privacy policy on its website stating exactly the information being collected and those individuals or companies with whom it is being shared. - See more at: http://consumercal.org/california-online-privacy-protection-act-caloppa/#sthash.0FdRbT51.dpuf<br>
      <br>
      According to CalOPPA, we agree to the following:<br>
      Users can visit our site anonymously.<br>
      Once this privacy policy is created, we will add a link to it on our home page or as a minimum, on the first significant page after entering our website.<br>
      Our Privacy Policy link includes the word 'Privacy' and can easily be found on the page specified above.<br>
      <br>
      You will be notified of any Privacy Policy changes:<br>
      • On our Privacy Policy Page<br>
      Can change your personal information:<br>
      • By emailing us<br>
      <br>
      How does our site handle Do Not Track signals?<br>
      We honor Do Not Track signals and Do Not Track, plant cookies, or use advertising when a Do Not Track (DNT) browser mechanism is in place.<br>
      <br>
      Does our site allow third-party behavioral tracking?<br>
      It's also important to note that we allow third-party behavioral tracking<br>
      <br>
      COPPA (Children Online Privacy Protection Act)<br>
      <br>
      When it comes to the collection of personal information from children under the age of 13 years old, the Children's Online Privacy Protection Act (COPPA) puts parents in control. The Federal Trade Commission, United States' consumer protection agency, enforces the COPPA Rule, which spells out what operators of websites and online services must do to protect children's privacy and safety online.<br>
      <br>
      We do not specifically market to children under the age of 13 years old.<br>
      Do we let third-parties, including ad networks or plug-ins collect PII from children under 13?<br>
      <br>
      Fair Information Practices<br>
      <br>
      The Fair Information Practices Principles form the backbone of privacy law in the United States and the concepts they include have played a significant role in the development of data protection laws around the globe. Understanding the Fair Information Practice Principles and how they should be implemented is critical to comply with the various privacy laws that protect personal information.<br>
      <br>
      In order to be in line with Fair Information Practices we will take the following responsive action, should a data breach occur:<br>
      We will notify you via email<br>
      • Within 7 business days<br>
      <br>
      We also agree to the Individual Redress Principle which requires that individuals have the right to legally pursue enforceable rights against data collectors and processors who fail to adhere to the law. This principle requires not only that individuals have enforceable rights against data users, but also that individuals have recourse to courts or government agencies to investigate and/or prosecute non-compliance by data processors.<br>
      <br>
      CAN SPAM Act<br>
      <br>
      The CAN-SPAM Act is a law that sets the rules for commercial email, establishes requirements for commercial messages, gives recipients the right to have emails stopped from being sent to them, and spells out tough penalties for violations.<br>
      <br>
      We collect your email address in order to:<br>
      • Send information, respond to inquiries, and/or other requests or questions<br>
      • Process orders and to send information and updates pertaining to orders.<br>
      • Send you additional information related to your product and/or service<br>
      • Market to our mailing list or continue to send emails to our clients after the original transaction has occurred.<br>
      <br>
      To be in accordance with CANSPAM, we agree to the following:<br>
      • Not use false or misleading subjects or email addresses.<br>
      • Identify the message as an advertisement in some reasonable way.<br>
      • Include the physical address of our business or site headquarters.<br>
      • Monitor third-party email marketing services for compliance, if one is used.<br>
      • Honor opt-out/unsubscribe requests quickly.<br>
      • Allow users to unsubscribe by using the link at the bottom of each email.<br>
      <br>
      If at any time you would like to unsubscribe from receiving future emails, you can email us at<br>
      • Follow the instructions at the bottom of each email.<br>
      and we will promptly remove you from ALL correspondence.<br>
      <br>
      Contact Us<br>
      <br>
      If there are any questions regarding this privacy policy, you may contact us using the information below:<br>
      <br>
      OHM SMALLDATA PTY LTD<br>
      Email: welcome@ohm.agency<br>
      <br>
      Last Edited on 2020-07-31
    </p>
  </section>
</template>
<style>
.Privacy {
  h2 { margin-bottom: 82px }
  p {
    max-width: 700px;

    line-height: 30px;
  }
}
</style>
